import React, { useEffect, useState } from "react";
import { getInProgressCoin } from "../../client";
import Hero from "../../components/Hero";
import Link from "../../components/Link";
import PartialPointList from "../../components/PartialPointList";
import InProgressCoinCard from "../../components/InProgressCoinCard";
import Faq, { convertSupportCentreToFaqs } from "../../components/Faq";
import { getAcfPartialContent, getZlaunchCoinWPInfo } from "../../utils";
import VideoPlayerIcon from "../../assets/svgs/video-player-icon.svg";
import "./style.scss";

const ZLaunchIconAndLogo = ({ productIcon, productName }) => {
  return (
    <div className="d-flex align-items-baseline mb-3">
      <img
        src={productIcon.publicURL}
        alt=""
        loading="eager"
        className="product-icon"
        width={25}
        height={25}
      />
      <span className="ml-3 h1 mb-0">{productName}</span>
    </div>
  );
};

const HeroButtons = ({ t }) => {
  return (
    <>
      <li className="list-inline-item mr-sm-3">
        <a
          className="button btn-watch-video"
          href={t("zlaunch.hero.videoLink")}
          target="_blank"
          rel="noreferrer noopener"
        >
          <VideoPlayerIcon className="mr-1" />
          {t("zlaunch.hero.watchVideo")}
        </a>
      </li>
      <li className="list-inline-item">
        <a
          className="button button-primary"
          href={`${t("common.exchangeLink")}/earn/zlaunch`}
          target="_blank"
          rel="noreferrer noopener"
        >
          {t("zlaunch.hero.lockToEarn")}
        </a>
      </li>
    </>
  );
};

const ZLaunchLayout = ({ data, lang, t }) => {
  const { pHeading: aboutZlaunchTitle, pContent: aboutZlaunchContent } =
    getAcfPartialContent(data.aboutZlaunch);
  const projectApplication = getAcfPartialContent(data.projectApplication);
  const heading = (
    <ZLaunchIconAndLogo
      productIcon={data.zlaunchIcon}
      productName={t("menu.earn.zlaunch.title")}
    />
  );

  const [inProgressCoins, setInProgressCoins] = useState();

  useEffect(() => {
    const getInProgressCoins = async () => {
      const coins = await getInProgressCoin(lang);
      setInProgressCoins(coins);
    };
    getInProgressCoins();
  }, []);

  return (
    <div id="zlaunch-page">
      <Hero
        classNames="zlaunch-page"
        backgroundColor="blue"
        backgroundImageInMobile={true}
        content={data.heroContent}
        customHeading={heading}
        customButtons={<HeroButtons t={t} />}
      />

      <div className="about-content container">
        <div className="row mx-4">
          <h2 className="header">{aboutZlaunchTitle}</h2>
          <div dangerouslySetInnerHTML={{ __html: aboutZlaunchContent }} />
        </div>
      </div>

      {inProgressCoins ? (
        <div className="in-progress">
          <div className="row mx-4 justify-content-center">
            <h2 className="header">{t("zlaunch.inProgress.title")}</h2>
          </div>
          <div className="in-progress__container">
            {inProgressCoins.map((coin) => {
              const coinWPInfo = getZlaunchCoinWPInfo(
                data.allWpNewCoinInfoItem,
                coin.rewardProduct.symbol
              );
              if (coinWPInfo) {
                return (
                  <div key={coin.poolId}>
                    <InProgressCoinCard
                      poolLockSymbol={coin.poolLockProduct.symbol}
                      rewardSymbol={coin.rewardProduct.symbol}
                      rewardName={coin.rewardProduct.name}
                      rewardDecimals={coin.rewardProduct.decimalPlaces}
                      rewardExcerpt={coinWPInfo.excerpt}
                      rewardIcon={coinWPInfo.icon}
                      rewardSlug={coinWPInfo.slug}
                      estimatedApy={coin.estimatedApy}
                      rewardTotalAmount={coin.rewardTotalAmount}
                      earningEndedAt={coin.earningEndedAt}
                      earningStartedAt={coin.earningStartedAt}
                    />
                  </div>
                );
              }
              return null;
            })}
          </div>
          <div className="row mx-4 justify-content-center">
            <Link
              to={`/coin-info/?type=ZLAUNCH_COIN`}
              className="button button-primary in-progress__button"
            >
              {t("zlaunch.inProgress.viewAllProjects")}
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="launch-project container">
        <div className="row mx-4">
          <h2 className="header">{projectApplication.pHeading}</h2>
        </div>
        <div className="row mx-4">
          <div className="col-sm-5">
            <img
              className="icon"
              src={projectApplication.pIcon.localFile.publicURL}
              alt=""
            />
          </div>
          <div className="col ml-sm-5">
            <div
              dangerouslySetInnerHTML={{ __html: projectApplication.pContent }}
            />
            <Link
              to={projectApplication.pButtonUrl}
              className="button button-primary mt-4 px-4"
            >
              {projectApplication.pButtonText}
            </Link>
          </div>
        </div>
      </div>

      <div className="container">
        <hr className="mx-4 my-0" />
      </div>

      <div className="container">
        <div className="row mx-4 mb-5">
          <h2 className="header">{t("zlaunch.whyChooseUs.title")}</h2>
          <PartialPointList
            points={data.whyZlaunchContent.edges}
            asHeader="h3"
            isAlignHorizontally={true}
            contentClassNames="text-small mb-5"
          />
        </div>
      </div>

      <div className="container">
        <Faq content={convertSupportCentreToFaqs(data.faqContent)} />
      </div>
    </div>
  );
};

export default ZLaunchLayout;
